import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"

import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.FiltroViajeCobranza;

export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void> | void;
    verSucursalCobranza?: boolean;
}

/**
* Valida un Entity
*/
export function validar(x: Entity) {
    const rules: validation.Rules<Entity> = {};
    return validation.getErrors(rules, x);
}

/**
* Componente para editar un Entity
*/
export class FiltroViajeRevisionComponent extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    errors = createSelectorRx(this.value, x => validar(x));
    hasError = createSelectorRx(this.errors, x => validation.hasError(x));
    getField = formfields(() => this.props, () => this.errors(this.props));
    private verSucursalCobranza = (props: Props) => props.verSucursalCobranza;

    render() {
        const { value } = this.props;
        const getField = this.getField;
        const verSucursalCobranza = this.verSucursalCobranza(this.props);

        const Text = getField(kea.Text);
        const Date = getField(kea.DateTime);
        const Number = getField(kea.Number);
        const SiNo = getField(selectores.SiNo);
        const Cobrador = getField(selectores.Cobrador);
        const Cliente = getField(selectores.Cliente);
        const Sucursal = getField(selectores.Sucursal);
        return (
            <div>
                {kea.autogrid(3, [
                    <Text field="Folio" label="Folio" />,
                    <Text field="SerieFolioFactura" label="Folio factura" />,
                    <Date field="FechaCreacionInicio" label="Fecha de creación (inicio)" time />,
                    <Date field="FechaCreacionFinal" label="Fecha de creación (final)" time />,
                ])}
            </div>);
    }
}



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cobranza/viajes/list/filtro.tsx